<template>
    <div class="filters-main-wrapper">
        <li v-if="['assets'].includes(filterReportContext)">
            <div class="config-label" style="width:50px">{{$t('Type')}}</div>
            <div class="config-value" style="width:calc(100% - 50px) !important">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <Multiselect
                            v-model="selectedAssetType"
                            :options="assetTypeDropdown"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            @select="updateAssetTypeFilter($event)"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            :placeholder="$t('Watch intervals')">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <span style="margin-inline-start:12px;">{{ scope.option }}</span>
                            </div>
                            <span slot="noResult">{{$t('No results')}}</span>
                        </Multiselect>
                    </div>
                </div>
            </div>
        </li>
        <li v-if="!['deleted permanently','duplicates','marked for delete','assets'].includes(filterReportContext)">
            <div class="config-label" style="width:50px">{{$t('Users')}}</div>
            <div class="config-value" style="width:calc(100% - 50px) !important">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <!-- <Multiselect
                            v-model="searchKey"
                            :options="userListFromAutocomplete"
                            :custom-label="selectionLabelCallback"
                            :track-by="username"
                            placeholder="Search User"
                            :hideSelected="false"
                            :close-on-select="true"
                            :limit="1"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            :resetAfter="false"
                            :showNoOptions="false"
                            @open="getAllUserNamesFromServer"
                            @search-change="getusersOnKeyup($event)"
                            @select="updateUsersFilter($event)"
                            @remove="optionsOnRemoveCallback()">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <div class="user-name-or-image" :style="style(scope.option.username)">{{ scope.option.username.split("")[0] }}</div>
                            <span style="margin-inline-start:12px;">{{ scope.option.username }}</span>
                            </div>
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option">
                            <span style="margin-inline-start:12px;">ALL</span>
                            </div>
                            <span slot="noResult">No results.</span>
                        </Multiselect> -->
                        <user-multi-select
                            :isSearchable="isPrivilegeExists('reports')"
                            :enableCheckbox="false"
                            :enableAllOption="true"
                            @updatedUsersList="handleUpdatedUsersList" 
                            :loggedInUserDataList="loggedInUserList"
                        >

                        </user-multi-select>
                    </div> 
                </div>       
            </div>
        </li>
        <li v-show="filterReportContext == 'auditTrail' || filterReportContext == 'jobs'">
            <div class="config-label" style="width:40px;">{{$t('Job')}}</div>
            <div class="config-value" style="width:calc(100% - 40px) !important">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <Multiselect
                            @focus="showUserFilter = false"
                            v-model="selectedJobName"
                            placeholder="Select Job" 
                            :custom-label="selectedJobLabelCallback"
                            :options="getJobNames()"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            label="label"
                            track_by="action_name"
                            :showNoOptions="false"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            @select="updateJobNameFilter($event)" 
                            >
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                            </div>
                            <span slot="noResult">{{$t('No results')}}</span>
                        </Multiselect>
                    </div>
                </div>       
            </div>
        </li>
        <li v-show="filterReportContext == 'jobs'">
            <div class="config-label" style="width:40px;">{{$t('State')}}</div>
            <div class="config-value" style="width:calc(100% - 40px) !important">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <!-- <Multiselect
                            @focus="showUserFilter = false"
                            v-model="selectedJobName"
                            placeholder="Select Job" 
                            :custom-label="selectedJobLabelCallback"
                            :options="getJobNames()"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            label="label"
                            track_by="action_name"
                            :showNoOptions="false"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            @select="updateJobNameFilter($event)" 
                            
                            :track-by="getJobNames.job_status">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                            </div>
                            <span slot="noResult">No results.</span>
                        </Multiselect> -->


                         <Multiselect
                            v-model="selectedJobStatus"
                            :options="allJobsStatuses"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            label="label"
                            :showNoOptions="false"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            style="margin-inline-start:6px;"
                            @select="updateJobStateFilter($event)"
                            track-by="job_status">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style="margin-inline-start:12px;">{{ $t(scope.option.label) }}</span>
                            </div>
                            <span slot="noResult">{{$t('No results')}}</span>
                        </Multiselect>
                    </div>
                </div>       
            </div>
        </li>
        <li v-show="['ingest','deleted permanently','marked for delete'].includes(filterReportContext)" style="margin-inline-end:10px">
            <div class="config-label" style="width:40px;">Bin</div>
            <div class="config-value" style="width:calc(100% - 40px) !important">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <Multiselect
                            @focus="showUserFilter = false"
                            v-model="selectedBin"
                            placeholder="Select Bin" 
                            :options="activeBinsArr"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            label="bin_name"
                            track_by="bin_id"
                            :showNoOptions="false"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            @select="updateBinNameFilter($event)">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style="margin-inline-start:12px;">{{ scope.option.bin_name }}</span>
                            </div>
                            <span slot="noResult">{{$t('No results')}}</span>
                        </Multiselect>
                    </div>
                </div>       
            </div>
        </li>
        
        <div class="comm-div">
            <label class="config-label" :style="['deleted permanently','marked for delete','assets'].includes(filterReportContext)?'width:100px':'width:45px'">{{getLabelName()}}</label>
            <Datepicker
                range
                @focus="showUserFilter=false"
                v-model="time1"
                valueType="format"
                placeholder="Select date range"
                @change="updateFilenameSearchKey()"
                class="bg-transparent rounded  text-light"
                style="height:38px !important" 
                :title="time1"
                :disabledDate="disabledDate"
                :style="['deleted permanently','marked for delete','assets'].includes(filterReportContext)?'width:calc(100% - 100px) !important':'width:calc(100% - 45px) !important'"
            ></Datepicker>
        </div>
        <div class="search-bar-comm-style comm-div" style="width: 20%;  height: 38px; padding: 0px !important;  display: inline-block;margin-inline-start: 10px">
            <div style="position:relative">
                <input
                type="text"
                v-model="fileNameFilter"
                class="bg-transparent rounded text-light w-100"
                :placeholder="['assets'].includes(filterReportContext)?'Enter slug name...':'Enter file name'"
                @focus="showUserFilter = false"
                @keyup.enter="updateFilenameSearchKey();"
                style="float:inline-start;padding-inline-end: 22px;"
                />
                <cancel-icon v-if="fileNameFilter.length > 0" @click="fileNameFilter = '',updateFilenameSearchKey()" style="position:absolute;inset-inline-end:1px;top:9px"></cancel-icon>
            </div>

            <!-- @keyup="updateFilenameSearchKey();" -->
            <!-- <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                class="bi bi-search"
                fill="#c5c0c0"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"
                />
                <path
                    fill-rule="evenodd"
                    d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
                />
            </svg> -->
        </div>
        <div class="primary-btn-style justify-content-end"  style="padding: 0px !important;display:inline-block;margin: 0px !important;float:inline-start">
            <button @click="updateFilenameSearchKey()" class="btn btn-outline-secondary m-2" style="width: 45px; margin: 0 !important; margin-inline-start: 9px !important; padding: 6px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                </svg>
            </button>
        </div>
        <div v-if="filterReportContext == 'auditTrail'" class="primary-btn-style justify-content-end"  style="padding: 0px !important;display:inline-block;margin: 0px !important;float:inline-start">
            <button @click="reloadAuditTrail()" class="btn btn-outline-secondary m-2" style="width: 45px; margin: 0 !important; margin-inline-start: 6px !important; padding: 6px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                    <title>{{$t('Reload')}}</title>
                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
    import { mapActions,mapGetters } from "vuex";
    import Multiselect from 'vue-multiselect';
    import Utils from "../../components.utils.js"
    import DatePicker from "vue2-datepicker";
    import "vue2-datepicker/index.css";
    import userMultiSelect from "../users/UserMultiselectField.vue";
    import moment from 'moment';
    import cancelIcon from "../core/InlineCancelField.vue";

    export default {
        props: ["reportContext"],
        data() {
            return {
                searchKey:"",
                userListFromAutocomplete:[],
                userGroupListFromAutocomplete:[],
                searchByUser:"",
                showUserFilter:false,
                showUserGroupFilter:false,
                searchByGroup:"",
                fileNameFilter:"",
                filterByAction:{
                    state:"All",
                    job_name:"All"
                },

                time1:null,
                selectedJobName:{
                    label:"All",
                    action_name:"All"
                },

                filtereddata : {},

                filterReportContext : "",

                requestingQueryParameters : {},
                selectedUsersList : [],
                loggedInUserList:[],
                selectedBin:[],
                activeBinsArr:[],
                assetTypeDropdown:[
                    'file', 'subclip'
                ],
                selectedAssetType:'file',
                selectedJobStatus : {
                    label:"All",
                    job_status:"All"
                },
                allJobsStatuses:[],
            }
        },
        computed:{
            ...mapGetters("users",["getLoggedInUserPrivilege"])
        },
        components:{
            Multiselect,  
            "Datepicker":DatePicker,
            "user-multi-select":userMultiSelect,
            "cancel-icon":cancelIcon
        },
        emits: ["changeSelectedReportComponent"],
        
        methods:{
            disabledDate(date) {
                const today = new Date();
                return date > today;
            },
            getLabelName(){
                if(this.filterReportContext == 'assets'){
                    return 'Created date'
                }
                else if(['deleted permanently','marked for delete'].includes(this.filterReportContext)){
                    return 'Deleted date'
                }else{
                    return 'Date'
                }
            },
            style(name){
                let style = {
                    'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                    'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
                }
                return style
            },

            selectedJobLabelCallback(option){
                return option.action_name;
            },

            sendFilteredparametrs(){
                this.requestingQueryParameters.page = 1;
                this.$emit("changeSelectedReportComponent", this.requestingQueryParameters);
            },

            reloadAuditTrail(){
                this.$emit("reloadAuditTrail");
            },
            
            getUserNameFromId(userId){
                let username = ""
                if(this.auditLogUserMap.length > 0){
                    let usermap = this.auditLogUserMap.filter((usersMap)=>(usersMap.user_id == userId))
                    if(typeof usermap != "undefined"){
                    username = usermap[0].username
                    }
                }
                return username
            },

            getusersOnKeyup(option){
                this.showUserFilter = true
                this.showUserGroupFilter = false
                let payload = {}
                // if(typeof(option) != "undefined" && option.trim().length > 0){
                if(typeof(option) != "undefined" && option.length > 0){  
                    payload.params = {username:option}
                    this.getUsersAutoComplitionFromServer(payload).then((data) => {
                    this.userGroupListFromAutocomplete = [];
                    this.userListFromAutocomplete = data["users"];
                    });
                }else if(option.length==0){
                    // this.updateUsersList(false);
                    // this.filterBy.user_id = "";
                    // this.updateJobsListFromServer(false,true, option);
                    // this.userListFromAutocomplete = this.usersList;
                    // delete this.selectedUserInfo._id;
                    // this.refreshAuditLogs(false)
                    this.getAllUsersFromServer(payload).then((data) => {
                    this.userListFromAutocomplete = data.users;
                    });
                }
            },

            hideUsersDropdown(){
                if(this.userListFromAutocomplete.length > 0 && this.searchByUser.length==0){
                    this.userListFromAutocomplete = [];
                }
            },
            selectionLabelCallback(option){
                return `${option.username}`
            },
            updateUsersFilter(option){
                this.selectedUserInfo["_id"] = option._id;
                this.searchKey = option.username;
                if(typeof this.selectedUserInfo != "undefined"){
                    this.requestingQueryParameters.user_id = this.selectedUserInfo._id
                }
                this.sendFilteredparametrs();
                // this.refreshAuditLogs(false);
            },

            getAllUserNamesFromServer(){
                this.getAllUsersFromServer().then((data) => {
                this.userListFromAutocomplete = data.users;
                });
            },

            getUserGroupsOnKeyup(){
                this.showUserGroupFilter = true
                this.showUserFilter = false
                let payload = {};
                payload.params = {user_id: this.selectedUserID};
                this.getAllUserGroupsFromServer(payload).then((data)=>{
                    this.userGroupListFromAutocomplete = data.user_groups;
                });
            },

            handleUpdatedUsersList(user){
                this.selectedUsersList = [];
                if(user._id != "all"){
                    this.selectedUsersList.push(user._id);
                    // this.selectedUserInfo["_id"] = this.selectedUsersList;
                    this.requestingQueryParameters.user_id  = JSON.stringify(this.selectedUsersList);
                   
                }else if(user._id == "all"){
                    delete this.requestingQueryParameters.user_id;
                }  
                
                 this.sendFilteredparametrs(); 
            },

            // handleRemovedUserFromList(userId){
            //     this.selectedUsersList = this.selectedUsersList.filter(e => e != userId);
            //     this.requestingQueryParameters.user_id  = this.selectedUsersList;
            //     this.sendFilteredparametrs(); 
            // },

            updateJobNameFilter(option){
                this.filterByAction["job_name"] = option.action_name;
                // this.selectedJobName = option.action_name;
                // this.updateJobsListFromServer(false,true);
                if(typeof this.filterByAction != "undefined" && (this.filterByAction.job_name.trim() <= 0 || this.filterByAction.job_name.trim() != "All")){
                    this.requestingQueryParameters["action"] = this.filterByAction.job_name;
                }else if(this.filterByAction.job_name.trim() == "All"){
                    delete this.requestingQueryParameters.action;
                }
                this.sendFilteredparametrs();            
                // this.refreshAuditLogs(false)

                // filtereddata["job_name"] = option.action_name;
            },
            updateJobStateFilter(option){
                this.filterByAction["state"] = option.job_status;
                if(typeof this.filterByAction != "undefined" && (this.filterByAction.state.trim() <= 0 || this.filterByAction.state.trim() != "All")){
                    this.requestingQueryParameters["state"] = this.filterByAction.state;
                }else if(this.filterByAction.state.trim() == "All"){
                    delete this.requestingQueryParameters.state;
                }
                this.sendFilteredparametrs();            
                // this.refreshAuditLogs(false)

                // filtereddata["job_name"] = option.action_name;
            },
            updateBinNameFilter(option){
                this.filterByAction["bin_id"] = option.bin_id;
                // this.selectedJobName = option.action_name;
                // this.updateJobsListFromServer(false,true);
                if(typeof this.filterByAction != "undefined" && (this.filterByAction.bin_id.trim() <= 0 || this.filterByAction.bin_id.trim() != "All")){
                    this.requestingQueryParameters["bin_id"] = this.filterByAction.bin_id;
                }else if(this.filterByAction.bin_id.trim() == "All"){
                    delete this.requestingQueryParameters.bin_id;
                }
                this.sendFilteredparametrs();   
            },

            updateAssetTypeFilter(option){
                this.requestingQueryParameters['type'] = option;
                this.sendFilteredparametrs();            
            },

            getJobNames(){
                var jobsNameList = this.getActionListFromInMem().filter((action)=>action.executed_as_job == true)
                if(this.isPrivilegeExists("Export")){
                    jobsNameList.push({
                        label: "Export",
                        action_name: "Export"
                    })
                }
                jobsNameList.unshift({
                    _id:"All",
                    action_name:"All",
                    label:"All"
                    },{
                    _id:"Create",
                    action_name:"Create",
                    label:"Create"
                    },{
                    _id:"Modify",
                    action_name:"Modify",
                    label:"Modify"
                    },{
                    _id:"Delete",
                    action_name:"Delete",
                    label:"Delete"
                    });
                return jobsNameList;
            },

            getActiveBins(){
                let payload = {};
                payload.params = {bin_type:"asset",status:"active"};
                this.getAllBinsFromServer(payload).then((data) => {
                    this.activeBinsArr =  data.bins;
                    this.selectedBin = this.activeBinsArr[0]
                    this.requestingQueryParameters["bin_id"] = this.selectedBin.bin_id;
                    this.$emit("changeSelectedReportComponent", this.requestingQueryParameters);
                })
            },
            updateFilenameSearchKey(){
                if(typeof this.fileNameFilter != "undefined" && this.fileNameFilter.trim().length > 0){
                    this.requestingQueryParameters["file_name"] = this.fileNameFilter
                    if(this.filterReportContext == 'auditTrail'){
                        this.requestingQueryParameters.filter=JSON.stringify(["file_name"])
                    }
                }else{
                    delete this.requestingQueryParameters.filter;
                    delete this.requestingQueryParameters.file_name;
                }  

                 if(typeof this.time1 != "undefined" &&
                    this.time1 != null && this.time1.length == 2 && this.time1[0] != null){
                    this.requestingQueryParameters.from_date = this.time1[0]+"T00:00:00"
                    this.requestingQueryParameters.to_date = this.time1[1]+"T23:59:59"
                    if(moment(new Date()).format("YYYY-MM-DD") == this.time1[1] || this.time1[0] == this.time1[1]){
                        this.requestingQueryParameters.to_date = this.time1[1]+"T23:59:59"
                    }
                }else{
                    delete  this.requestingQueryParameters.from_date;
                    delete  this.requestingQueryParameters.to_date;
                }
                this.sendFilteredparametrs();              
            },
            // callRespectiveGetRequest(){
            //     if(this.filterReportContext == "ingest"){

            //     }
            // },
            isPrivilegeExists(privilegeName){
                return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, privilegeName);
            },

            ...mapActions("users", ["getAllUsersFromServer","getUsersAutoComplitionFromServer"]),
            ...mapGetters("privileges",["getActionListFromInMem"]),
            ...mapGetters("users",["getLoggedInUser","getLoggedInUserId"]),
            ...mapActions("bins",['getAllBinsFromServer']),
            ...mapActions("jobs", ["getAllJobsStatusFromServer"]),
        },
        created(){
            this.filterReportContext = this.reportContext;
            this.loggedInUserList.push({"username":this.getLoggedInUser(),"_id":this.getLoggedInUserId()});
            let loggedInUserIdForDefaultSearchList = [];
            loggedInUserIdForDefaultSearchList.push(this.getLoggedInUserId());
            this.requestingQueryParameters.user_id = JSON.stringify(loggedInUserIdForDefaultSearchList);
            if(['ingest','deleted permanently','marked for delete'].includes(this.filterReportContext)){
                this.getActiveBins();
            }

            this.getAllJobsStatusFromServer().then((data)=>{
                this.allJobsStatuses = data.job_statuses;
                this.allJobsStatuses.unshift({
                label:"All",
                job_status:"All"
                });
            });
        }
    }
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $secondary-border-hover-color:#767676;

    .filters-main-wrapper{
        width:calc(100% - 60px);
        float: inline-start;
    }

    .search-bar-comm-style {
        height: 30px;
        position: relative;
        input {
            border: $border-color !important;
            height: 38px !important;
            padding-inline-start: 8px;
        }
        // svg {
        //     position: absolute;
        //     inset-inline-start:4px;
        //     top: 34%;
        // }
    }

    li {
      width: 24%;
      display: inline-flex;
      // margin-bottom: 20px;
    }

    .config-label {
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        height: 100%;
        align-items: center;
        display: inline-flex;
        justify-content: end;
    }
  
    .config-value {
        margin-inline-start: 4px;
        width: 75% !important;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }

    .value-style {
        color: $text-color;
        width: 97%;
        text-align: start;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
    }
    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }

    .user-name{
        margin-inline-end: 10px;
        position: relative;
        bottom: 7px;
    }
    
    input:focus{
        outline:none;
        box-shadow: none;
    }

    div.comm-div{
        display:inline-flex;
        width:30%;
        // padding-top:7px;
        position: relative;
        // inset-inline-end :2%;
        label{
        color:$dull-text-color;
        position: relative;
        inset-inline-end: 5px;
        width:30%;
        text-align:end;
        top:2px;
        }
        select,input{
            width:70%;
            height:27px;
            border:$border-color;
        }
    }

    input:hover{
        border: 1px solid $secondary-border-hover-color !important;
    }

    .btn-outline-primary.focus, .btn-outline-primary:focus{
        box-shadow: none !important;
    }
    
    ::v-deep {

        .mx-input{
            background-color:$primary-background !important;
            border: none !important;
            color: #eee !important;
            height:100%;
        }
        .mx-input-wrapper{
        width:100%;
        height:100%;
        }
        .mx-datepicker-main{
            border: $border-color !important;
            background: $secondary-background-color !important;
        }
        .mx-calendar-content .cell:hover{
            background-color:  $bg-color-on-hover !important;
        }
        .mx-datepicker-range{
            width:100%;
            height:100% !important;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-datepicker{
            width:100% !important;
            padding: 0 !important;
            border:$border-color !important;
            height: 27px !important;
        }

        .mx-datepicker:hover, mx-datepicker-range:hover{
            border:1px solid $secondary-border-hover-color !important;
        }
        .mx-icon-calendar, .mx-icon-clear{
            color: #d7d2d280;
        }

                .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-start;
            display:none;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
        .multiselect__tag {
            background-color: $primary-background !important;
        }
        .multiselect__tags{
            background-color: $primary-background !important;
            border:none !important;
            padding: 0px 40px 0 0px !important;
        }
        .multiselect:hover{
            border:1px solid $secondary-border-hover-color !important;
        }

        // .status-field{
        //     .multiselect__tags{
        //         background: transparent !important;
        //         border: 1px solid #5a5a5a !important;
        //         padding: 0px 40px 0 0px !important;
        //     }
        // }

        .multiselect__option{
            
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
            align-items: center;
            margin:0px !important;
            height: 100%;
            padding-inline-start: 7px;
            padding-top: 0px !important;
        }
        .multiselect__single {
            margin: 0px !important;
            height: 100%;
            display: flex;
            align-items: center;
        }  
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color !important;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 23px;
        }
        .multiselect *{
            font-size: 14px !important;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect{
        color:$text-color !important;
        font-size: 12px !important;
        height: $input-field-height !important;
        min-height: $input-field-height !important;
        border:$border-color;
        border-radius: 5px;
        // width:250px;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            // border: 1px solid #292828 !important;
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: auto;
            min-width: 100%;
            max-height: 240px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color!important;
        }
        .multiselect__tags {
            background: $primary-background;
            padding-inline-start: 0px !important;
            height: $input-field-height;
            min-height: $input-field-height;
            display: flex;
            align-items: center;
            margin:0px !important;
            height: 100%;
            // padding-inline-start: 8px !important;
        }

        .multiselect__placeholder{
            display: flex;
            align-items: center;
            margin:0px !important;
            height: 100%;
            padding-inline-start: 5px;

        }
        .multiselect__select:before {
            top:55%;
        }
    }
</style>
